/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking how long a task takes for billing or time-boxing freelance and client work.`)
};

const es_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar cuánto dura una tarea para facturación o para acotar el tiempo de trabajo freelance con clientes.`)
};

const de_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgen, wie lange eine Aufgabe dauert, für Abrechnung oder Timeboxing bei freiberuflicher oder Kundenarbeit.`)
};

const nl_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijhouden hoe lang een taak duurt voor facturatie of het timeboxen van freelance- en klantwerk.`)
};

const fr_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre la durée d’une tâche pour la facturation ou le time-boxing d’un travail en freelance ou pour un client.`)
};

const it_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciare quanto tempo richiede un'attività per la fatturazione o per il time-boxing di lavori freelance e con i clienti.`)
};

const pt_br2_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhar quanto tempo uma tarefa leva para cobrança ou para limitar o tempo de trabalhos freelance e com clientes.`)
};

const pt_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar quanto tempo demora uma tarefa para faturação ou para delimitar trabalho freelance e de clientes.`)
};

const ja_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求や時間管理のために、フリーランスやクライアント業務でタスクにかかった時間を計測する。`)
};

const zh_timer_stopwatch_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追踪任务耗时，用于自由职业和客户工作的计费或时间盒管理。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_use2", locale)
	if (locale === "en") return en_timer_stopwatch_use2(inputs)
	if (locale === "es") return es_timer_stopwatch_use2(inputs)
	if (locale === "de") return de_timer_stopwatch_use2(inputs)
	if (locale === "nl") return nl_timer_stopwatch_use2(inputs)
	if (locale === "fr") return fr_timer_stopwatch_use2(inputs)
	if (locale === "it") return it_timer_stopwatch_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_use2(inputs)
	if (locale === "pt") return pt_timer_stopwatch_use2(inputs)
	if (locale === "ja") return ja_timer_stopwatch_use2(inputs)
	return zh_timer_stopwatch_use2(inputs)
};